import { getSpeakerLabel, Participant, SpeakerLike } from '../config/participants';
import { ALERT_SPEAKER_COPY, AlertViewer, isViewersOwnAlert } from '../constants/alertTheme';

/**
 * The speaker word before a live line in the Transcript bar's preview, on the
 * alert labels' rule (2026-10-05): "You" only for the viewer's own participant
 * (a line naming nobody, from an older service, is the call owner's own when a
 * salesperson said it). Another salesperson's line shows their roster name,
 * else the line's own name, else "Salesperson"; a customer's line is labelled
 * as before. A watcher has no own participant, so it is never "You": the
 * owner's lines used to read "You" on every co-seller's and watcher's screen.
 */
export function transcriptSpeakerLabel(line: SpeakerLike, roster: Participant[], viewer: AlertViewer): string {
  if (isViewersOwnAlert(line, viewer)) return ALERT_SPEAKER_COPY.you;
  return getSpeakerLabel(line, roster, {
    salespersonLabel: line?.speakerName?.trim() || ALERT_SPEAKER_COPY.salesperson,
  });
}
